enum IRate {
  GREAT = 3,
  OKAY = 2,
  BAD = 1,
}

export default IRate;
